import React, {useContext} from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import TableHeader from "../../Components/Common/TableHeader";
import Loader from "../../Components/Common/Loader";
import { Link } from "react-router-dom";
import SchoolContext from "../../Context/SchoolContext";
import AddTerm from "../../Components/Settings/SchoolTerm/AddTerm";

function TermsPage() {
  const {schoolTermList, getTermsList} = useContext(SchoolContext);

  const refreshData = () =>{
    getTermsList()
  }

  return (
    <AppContainer title="School Terms">
      <div className="row">
        <div className="col-lg-4">
          <AddTerm/>
        </div>
        <div className="col-lg-8">
          <div className="card custom-card">
            <div className="card-body map-card">
              <div class="heading-layout1 mg-b-25">
                <TableHeader
                  title="School Terms List"
                  subtitle="List of all the school terms sorted in ascending order"
                />
                <div class="dropdown">
                                        <Link class="dropdown-toggle" role="button" 
                                        data-toggle="dropdown" aria-expanded="false">...</Link>
                
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <Link class="dropdown-item" onClick={refreshData} ><i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link>
                                        </div>
                                    </div>
              </div>

              <div className="table-responsive">
                <table className="table table-hover text-nowrap mg-b-0">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Term Name</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Status</th>

                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(schoolTermList) && schoolTermList.map((item, key) => (
                        <tr>
                          <td>{key + 1}</td>
                          <td>{item.term_name} </td>
                          <td>{item.start_date_fmt?.short_date} </td>
                          <td>{item.end_date_fmt?.short_date} </td>
                          <td>{item.is_active === "Active" ? <span class="badge badge-success">ACTIVE </span>:""}</td>

                        </tr>
                      ))}
                      {schoolTermList === "404" && (<tr>
                          <td colSpan="5" style={{textAlign: "center"}}>
                            No school terms registered yet.
                          </td>
                        </tr>)}
                  </tbody>
                </table>
                {!schoolTermList && <Loader />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
}

export default TermsPage;
